/* BYC 2026-10-14：見出し画像を、一部だけが動く短い動画（シネマグラフ）に差し替える。
   動画は同じ画像から作った5秒の動画で、カメラは固定。水・煙・灯り・霧だけが動く。終わりと始まりは重ねてつなぐ。
   画像はそのまま下に残し、動画が再生できたら上にふわっと重ねる。画面の外では止める。
   生産者の動画は煙がゆっくり見えるよう0.55倍速で流す。動きを減らす設定の人、データ節約設定の人には動画を出さない。 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var conn = navigator.connection; if (conn && conn.saveData) return;
  /* 画像ファイル名の一部 → 動画（PC用, スマホ用） */
  var V = window.BYC_MOTION || {
    'byc-hero-producers': ['https://cdn.shopify.com/s/files/1/0548/7758/5477/files/byc-hero-producers-loop3.mp4?v=1791970286', null, 0.55],
    'byc-hero-guide': ['https://cdn.shopify.com/s/files/1/0548/7758/5477/files/byc-hero-guide-loop3.mp4?v=1791970286'],
    'byc-hero-voyage': ['https://cdn.shopify.com/s/files/1/0548/7758/5477/files/byc-hero-voyage-loop3.mp4?v=1791970286'],
    'byc-hero-stock': ['https://cdn.shopify.com/s/files/1/0548/7758/5477/files/byc-hero-stock-loop.mp4?v=1791968319'],
    'byc-hero-dispatch': ['https://cdn.shopify.com/s/files/1/0548/7758/5477/files/byc-hero-dispatch-loop3.mp4?v=1791970286'],
    'byc-hero-booking': ['https://cdn.shopify.com/videos/c/o/v/f659c5cc09324ec0a16258c7d6d691f2.mp4', 'https://cdn.shopify.com/videos/c/o/v/51902f12905047ac92e94e12c02c2f46.mp4'],  /* 2026-10-15 作り直し（摘み手が動く）。前の版はほぼ動かなかった */
    'byc-hero-about': ['https://cdn.shopify.com/s/files/1/0548/7758/5477/files/byc-hero-about-loop.mp4?v=1791988146'],
    'byc-hero-varieties': ['https://cdn.shopify.com/s/files/1/0548/7758/5477/files/byc-hero-varieties-loop.mp4?v=1791968939']
  };
  var keys = Object.keys(V); if (!keys.length) return;
  var SP = window.matchMedia('(max-width: 749px)').matches;

  /* つなぎ目を見せないループ：同じ動画を2本重ね、終わる少し前から次の1本を頭から再生して、ゆっくり入れ替える */
  var FADE = 1.2;
  function mk(box, img, cs, src, rate) {
    var v = document.createElement('video');
    v.className = 'byc-mo-video'; v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.preload = 'auto'; v.disablePictureInPicture = true;
    v.style.objectFit = cs.objectFit || 'cover'; v.style.objectPosition = cs.objectPosition;
    v.src = src; if (rate) { v.defaultPlaybackRate = rate; v.playbackRate = rate; }
    img.insertAdjacentElement('afterend', v);
    return v;
  }
  function attach(img, src, rate) {
    rate = rate || 1;
    var box = img.parentElement;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var cs = getComputedStyle(img);
    var b = mk(box, img, cs, src, rate), a = mk(box, img, cs, src, rate);   /* a が手前 */
    var cur = a, nxt = b, visible = false, swapping = false;
    var play = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    a.addEventListener('playing', function () { a.classList.add('is-on'); }, { once: true });
    function tick() {
      if (!visible) return;
      var d = cur.duration;
      if (d && !swapping && cur.currentTime >= d - FADE * rate) {
        swapping = true;
        nxt.currentTime = 0; nxt.playbackRate = rate; play(nxt);
        nxt.style.transition = 'none'; nxt.style.zIndex = 1; cur.style.zIndex = 0;
        nxt.classList.add('is-on'); nxt.style.opacity = '0';
        requestAnimationFrame(function () { nxt.style.transition = 'opacity ' + FADE + 's linear'; nxt.style.opacity = '1'; });
        setTimeout(function () { cur.pause(); var t = cur; cur = nxt; nxt = t; nxt.style.opacity = '0'; swapping = false; }, FADE * 1000 + 60);
      }
      requestAnimationFrame(tick);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) {
        visible = e.isIntersecting;
        if (visible) { play(cur); requestAnimationFrame(tick); } else { cur.pause(); nxt.pause(); }
      }); }, { threshold: 0.05 }).observe(box);
    } else { visible = true; play(cur); requestAnimationFrame(tick); }
  }

  function init() {
    document.querySelectorAll('.byc-phero > img, .bycbl-hero > img').forEach(function (img) {
      var s = img.currentSrc || img.src || '', hit = null;
      keys.forEach(function (k) { if (s.indexOf(k) > -1) hit = V[k]; });
      if (!hit) return;
      attach(img, SP && hit[1] ? hit[1] : hit[0], hit[2]);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
/* BYC 2026-10-14：長いページで「トップに戻る」ボタンを出す。画面1つ分ほど下に進んだら右下に出す（トップの旅の途中も出す）。
   焼豆サンプルの注文の帯や、プレビュー時のShopifyのバーなど、画面下に固定されたものがあれば、その上に浮かせる。 */
(function () {
  function start() {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'byc-totop'; var ES = (document.documentElement.lang || '').slice(0, 2) === 'es';  /* 2026-10-19 スペイン語版 */
    b.setAttribute('aria-label', ES ? 'Volver al inicio de la página' : 'ページの一番上に戻る'); b.setAttribute('title', ES ? 'Volver arriba' : 'トップに戻る'); b.hidden = true;
    b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg><span>TOP</span>';
    document.body.appendChild(b);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    var tick = false;
    function lift(el) {
      if (!el) return 0;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight && r.bottom >= window.innerHeight - 4) return window.innerHeight - r.top + 12;
      return 0;
    }
    function upd() {
      tick = false;
      b.hidden = !(window.scrollY > window.innerHeight * 1.2);
      var off = 20;
      document.querySelectorAll('.bycso-bar, .bycb-fab:not([hidden]), #PBarNextFrameWrapper, #preview-bar-iframe, #shopify-pc__banner').forEach(function (el) { off = Math.max(off, lift(el)); });
      b.style.bottom = 'calc(' + off + 'px + env(safe-area-inset-bottom))';
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd);
    upd(); setTimeout(upd, 1500);
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
